<ng-container *transloco="let t; read: 'settings'">
<h2 class="mbm">{{ t('ressourceCategories') }}</h2>
<kendo-grid
  [data]="ressourceCategorys"
  (edit)="editHandler($event)"
  (cancel)="cancelHandler($event)"
  (save)="saveHandler($event)"
  (remove)="removeHandler($event)"
  (add)="addHandler($event)"
  [style.maxHeight.px]="600"
>
  <ng-template kendoGridToolbarTemplate>
    <button 
      *permissionIf="'Permissions.RessourceCategories.Create'"
      kendoGridAddCommand>{{ t('add') }}</button>
  </ng-template>
  <kendo-grid-column field="name" [title]="t('name')"> </kendo-grid-column>

  <kendo-grid-column field="color" [title]="t('color')">
    <ng-template kendoGridCellTemplate let-dataItem>
      <kendo-colorpicker
        [value]="dataItem.color"
        disabled="true"
      >
      </kendo-colorpicker>
    </ng-template>
    <ng-template
      kendoGridEditTemplate
      let-dataItem="dataItem"
      let-column="column"
      let-formGroup="formGroup"
    >
      <kendo-colorpicker
        [value]="dataItem.color"
        [formControl]="formGroup.get('color')"
        format="hex"
      >
      </kendo-colorpicker>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-command-column
    [title]="t('action')"
  >
    <ng-template kendoGridCellTemplate let-isNew="isNew">
      <button 
        *permissionIf="'Permissions.RessourceCategories.Update'"
        kendoGridEditCommand themeColor="primary">{{ t('edit') }}</button>
      <button 
        *permissionIf="'Permissions.RessourceCategories.Delete'"
        kendoGridRemoveCommand>{{ t('remove') }}</button>
      <button kendoGridSaveCommand [disabled]="formGroup?.invalid">
        {{ isNew ? t('add') : t('save') }}
      </button>
      <button kendoGridCancelCommand>
        {{ isNew ? t('discard') : t('cancel') }}
      </button>
    </ng-template>
  </kendo-grid-command-column>
</kendo-grid>

<app-delete-confirm-dialog
  [(opened)]="deletionDialogOpened"
  [message]="t('deletionMessages.ressourceCategory')"
  (confirmed)="deleteConfirmed()"
></app-delete-confirm-dialog>
</ng-container>
